import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { formatNumericList } from '../metadata-inspection.utils';

@Component({
  selector: 'dbw-investor-details',
  imports: [RouterLink],
  template: `
    <div
      class="dbw-investor-details"
      [class.content-long]="layout() === 'long'"
      [class.content-short]="layout() === 'short'"
    >
      @if (link()) {
        <a [routerLink]="link()"><strong>{{ displayName() || 'Investisseur sans nom' }}</strong></a>
      } @else {
        <strong>{{ displayName() || 'Investisseur sans nom' }}</strong>
      }
      <div>#{{ investorId() }} • {{ investorCode() || 'Code inconnu' }}</div>

      @for (detail of details(); track detail) {
        <div>{{ detail }}</div>
      }

      @if (showPersonIds()) {
        <div>Personnes physiques Atlas: {{ personIdsLabel() }}</div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    .dbw-investor-details {
      display: grid;
      gap: 0.2rem;
    }
  `
})
export class InvestorDetailsComponent {
  readonly investorId = input.required<number>();
  readonly displayName = input<string | null | undefined>();
  readonly investorCode = input<string | null | undefined>();
  readonly link = input<string | null | undefined>();
  readonly details = input<string[]>([]);
  readonly atlasPersonnePhysiqueIds = input<number[]>([]);
  readonly showPersonIdsWhen = input<'never' | 'multiple' | 'always'>('multiple');
  readonly layout = input<'long' | 'short'>('long');

  readonly showPersonIds = computed(() => {
    const mode = this.showPersonIdsWhen();
    const ids = this.atlasPersonnePhysiqueIds();

    if (mode === 'never') {
      return false;
    }

    if (mode === 'always') {
      return ids.length > 0;
    }

    return ids.length > 1;
  });

  readonly personIdsLabel = computed(() => formatNumericList(this.atlasPersonnePhysiqueIds()));
}
